import { module } from "angular";
import { AlarmVideoOverlayComponent } from "./AlarmVideoOverlayComponent";

module("mmGui").component("irAlarmVideoOverlay", new AlarmVideoOverlayComponent());
